export default "__VITE_ASSET__CxFc3JmM__"